import React from 'react';

import { useSkipRedirectSwitch } from '@/availability-fallback/hooks';
import { useMembershipServicesModeState } from '@/membership-services/hooks/use-membership-services-mode-state.hook';
import { useSessionId } from '@/session/use-session-id.hook';

import { EnnismoreAPIClientConfigContext } from '../contexts';
import { type EnnismoreAPIClientCompositeConfig } from '../interfaces';

interface EnnismoreAPIProviderProps {
  children: React.ReactNode;
  config: EnnismoreAPIClientCompositeConfig;
}

export const EnnismoreApiProvider: React.FC<EnnismoreAPIProviderProps> = (
  props
) => {
  // We're mutating below so grab a copy of the config
  const config = {
    kong: { ...props.config.kong, gatewayType: 'kong' as const },
    awsApiGateway: {
      ...props.config.awsApiGateway,
      gatewayType: 'aws-api-gateway' as const,
    },
  };
  const [skipRedirect] = useSkipRedirectSwitch();
  const [membershipMode] = useMembershipServicesModeState();

  // If the user has 'skip-redirect' enabled at the feature level
  if (skipRedirect) {
    config.awsApiGateway.skipRedirect = true;
    config.kong.skipRedirect = true;
  }

  if (membershipMode) {
    config.awsApiGateway.membershipMode = true;
    config.kong.membershipMode = true;
  }

  return (
    <EnnismoreAPIClientConfigContext.Provider value={config}>
      {props.children}
    </EnnismoreAPIClientConfigContext.Provider>
  );
};
